import atob from "atob"
import pako from "pako"
import {drawWatermark} from "./drawWatermark"
import "whatwg-fetch"

export class SvgPage {
  constructor(url, elem, pageIndex, includeWatermark, personalization, onPageLoaded) {
    this.url = url
    this.elem = elem
    this.pageIndex = pageIndex
    this.includeWatermark = includeWatermark
    this.personalization = personalization
    this.svg = null
    this.svgWidth = null
    this.svgHeight = null
    this.onPageLoaded = onPageLoaded
    this.svgContainerElem = null
    this.shouldDisplay = false
    this.isDisplaying = false
  }

  get pageNum() {
    return this.pageIndex + 1
  }

  async load() {
    const svgResponse = await fetch(this.url)
    if (!svgResponse.ok) {
      console.log(`svgResponse not ok`, svgResponse)
    }
    else {
      const svgCompressedB64 = await svgResponse.text()
      const svgCompressed = atob(svgCompressedB64)
      const svgCompressedBuf = binstring2buf(svgCompressed)
      const svgStr = pako.inflate(svgCompressedBuf, { to: 'string' })
      const svgStruct = JSON.parse(svgStr)
      this.svg = svgStruct.svg[1]
      this.svgWidth = svgStruct.width
      this.svgHeight = svgStruct.height

      this.svgContainerElem = document.createElementNS("http://www.w3.org/2000/svg", "svg")
      this.svgContainerElem.classList.add("centeredSvg")
      this.svgContainerElem.setAttribute("width", this.svgWidth)
      this.svgContainerElem.setAttribute("height", this.svgHeight)
      this.elem.appendChild(this.svgContainerElem)

      this.updateElements()

      this.onPageLoaded()
    }
  }

  updateElements() {
    if (this.shouldDisplay) {
      this.show()
    }
    else {
      this.hide()
    }
  }

  show() {
    if (!this.isDisplaying) {
      if (this.svgContainerElem != null) {
        this.svgContainerElem.innerHTML = this.svg
        // The svg's top-level contains a <g> tag that tries to position
        // the page vertically.  Remove that transform.
        const pageG = this.svgContainerElem.firstChild
        // FIXME - check that pageG is the "g" element we're expecting
        pageG.removeAttribute("transform")

        if (this.includeWatermark) {
          drawWatermark(pageG)
        }

        if (this.personalization != null) {
          this.drawPersonalization(pageG)
        }
        
        this.isDisplaying = true
      }
    }
  }

  drawPersonalization(svg) {
    const g = document.createElementNS("http://www.w3.org/2000/svg", "g")

    g.setAttribute("font-family", "NeueHaasGroteskTextPro")
    g.setAttribute("font-size", "8")
    g.setAttribute("font-style", "normal")
    g.setAttribute("font-weight", "normal")
    g.setAttribute("text-decoration", "none")
    g.setAttribute("stroke", "none")
    g.setAttribute("fill", "rgba(0,0,0,1)")
    g.setAttribute("transform", "translate(0, 778)")
    g.setAttribute("text-anchor", "middle")

    svg.appendChild(g)
    const text = document.createElementNS("http://www.w3.org/2000/svg", "text")
    text.setAttribute("x", this.svgWidth / 2.0)
    g.appendChild(text)
    const textNode = document.createTextNode(this.personalization)
    text.appendChild(textNode)
  }

  hide() {
    if (this.isDisplaying) {
      if (this.svgContainerElem != null) {
        this.svgContainerElem.innerHTML = ""
        this.isDisplaying = false
      }
    }
  }

  setScale(scale) {
    // The svg's top-level contains a <g> tag that tries to position
    // the page vertically.  Remove that transform.
    const pageG = this.svgContainerElem.firstChild
    // FIXME - check that pageG is the "g" element we're expecting
    pageG.setAttribute("transform", `scale(${scale},${scale})`)
    this.svgContainerElem.setAttribute("width", this.svgWidth * scale)
    this.svgContainerElem.setAttribute("height", this.svgHeight * scale)
  }
}

function binstring2buf (str) {
  const buf = new Uint8Array(str.length)
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};
